ulekareApp.factory('AnalyticsLogger', function(C, AskFormStorage) {

	var AnalyticsLogger = function() {
	};

	AnalyticsLogger.prototype = {
		'isOrder': function() {
			return C.isOrder === true || AskFormStorage.get('forceOrder') === true;
		},
		'isPartner': function() {
			return C.isPartner === true;
		},
		'isSubscription': function() {
			return C.isSubscription === true;
		},
		'getFormTypeTitle': function() {
			if (this.isSubscription() === true) {
				return 'Darkovy poukaz';
			}
			var formTypeTitle = this.isOrder() ? 'Objednat se k lekari' : 'Poradit se s lekarem';
			if (this.isPartner() === true) {
				formTypeTitle += ' - HRB';
			}

			return formTypeTitle
		},
		'push': function(content) {
			dataLayer.push(content);

			return true;
		},
		'logPageEnter': function() {
			this.push({
				'content': 'Formular: ' + this.getFormTypeTitle(),
			});
		},
		'logVirtualPageView': function(pageName) {
			return this.push({
				'event': 'virtualPageView',
				'formStep': (this.isPartner() ? '/hrb' : '') + pageName
			});
		},
		'logStep': function(step) {
			switch (step) {
				case C.steps.formServiceSelect:
					this.logVirtualPageView('/0-vyber-sluzby');
					break;
				case C.steps.formEnter:
					if (this.isOrder() === true) {
						this.logVirtualPageView('/1-odeslani-objednavky');
					} else if (this.isSubscription() === true) {
						this.logVirtualPageView('/1-objednani-poukazu');
					} else {
						this.logVirtualPageView('/1-polozeni-dotazu');
					}
					break;
				case C.steps.tariffSelect:
					this.logVirtualPageView('/2-vyber-tarifu');
					break;
				case C.steps.authorizationForm:
					this.logVirtualPageView('/2-autorizacni-formular-benefitu');
					break;
				case C.steps.authorizationRequestSent:
					this.logVirtualPageView('/3-zadost-o-outorizaci-odeslana');
					break;
				case C.steps.authorizationDone:
					this.logVirtualPageView('/hrb/4-dotaz-autorizovan');
					break;
				case C.steps.paymentMethodSelect:
					this.logVirtualPageView('/3-zpusob-platby');
					break;
				case C.steps.paymentError:
					this.logVirtualPageView('/X-platba-se-nezdarila');
					break;
				case C.steps.thankYou:
					this.logVirtualPageView(this.isOrder() || this.isSubscription() ? '/2-podekovani' : (this.isPartner() ? '/4-podekovani' : '/5-podekovani'));
					break;
			}
		},
		'logFormInteraction': function(fieldName, fieldValue) {
			return this.push({
				'event': 'formInteraction',
				'actionType': 'Interakce s formularem: ' + this.getFormTypeTitle(),
				'fieldName': fieldName,
				'fieldValue': fieldValue || ''
			});
		},
		'logStartForm': function(formName) {
			return this.push({
				event: 'form_start',
				'form.name': formName
			});
		},
		'logEndForm': function(formName) {
			return this.push({
				event: 'form_sent_success',
				'form.name': formName
			});
		}
	};

	return new AnalyticsLogger();

});
